/**
 * Masks a username for display purposes by showing only the first
 * few characters followed by asterisks. Matches the mobile (atlas)
 * implementation for consistency across platforms.
 *
 * Usernames starting with "test" show 5 characters before masking
 * to avoid all masked usernames looking identical in test environments.
 */
export function maskUsername(username: string): string {
  if (!username) return "*******";
  const length = username.startsWith("test") ? 5 : 4;
  return `${username.slice(0, length)}*******`;
}
